import React from 'react';
import './IconRipple.css';

function IconRipple() {
  return (
    <div className="lds-ripple">
      <div></div>
      <div></div>
    </div>
  );
}

export default IconRipple;
